/* eslint-disable react/jsx-no-bind */
import React, {useEffect} from 'react';
import TypeIcon from './editor/TypeIcon';
import {constants} from '@neosvoc/nv-platform-core-common';
import {useStore} from 'react-redux';
import {FormattedMessage} from 'react-intl';
import TooltipIcon from '../TooltipIcon';
import messages from '../../../res/translations/messages';


const SurveyEditorRatingPreview = ({min=0, max=10, rangesColors}) => {
    const [stars, setStars] = React.useState([]);
    const [primaryColor, setPrimaryColor] = React.useState('#ddd');
    const [hoverIndex, setHoverIndex] = React.useState(null);
    const [starEnterHandlers, setStarEnterHandlers] = React.useState({});
    const store = useStore();
    const getEnterHandler = (index) => {
        if (!starEnterHandlers[index]) {
            setStarEnterHandlers((prev) => {
                prev[index] = () => handleMouseEnter(index); return prev;
            });
        }
        return starEnterHandlers[index];
    };
    const handleMouseEnter = (index) => {
        setHoverIndex(index);
    };

    const handleMouseLeave = () => {
        setHoverIndex(null);
    };
    const getColorForValue = (starValue, ranges, primaryColor) => {
        for (let i = 0; i < ranges.length; i++) {
            if (starValue <= ranges[i].value) {
                return ranges[i].color;
            }
        }
        return primaryColor;
    };
    useEffect(() => {
        setStars(Array.from({length: max - min + 1}, (_, i) => min + i));
    }, [min, max]);

    useEffect(() => {
        if (store.getState().organization.current) {
            setPrimaryColor(store.getState().organization.current ? store.getState().organization.current.branding.primaryColor : '#ddd');
        }
    }, [store]);

    return (
        <div>
            <label className="col-form-label mb-2">
                <FormattedMessage {...messages.surveys.form.label.ratingPreview} />{' '}
                <TooltipIcon message={messages.surveys.form.tooltip.number2.ratingPreview} />
            </label>
            <div style={{display: 'flex', alignItems: 'flex-center', gap: '4px', justifyContent: 'center', flexWrap: 'wrap', rowGap: '30px', maxWidth: '100%'}}>
                {stars.map((starValue, index) => {
                    const isActive = hoverIndex !== null ? index <= hoverIndex : false;
                    const color = getColorForValue(starValue, rangesColors, primaryColor);
                    return (
                        <div key={starValue} style={{display: 'flex', flexDirection: 'column', alignItems: 'center', position: 'relative'}}
                            onMouseEnter={getEnterHandler(index)}
                            onMouseLeave={handleMouseLeave}>
                            <TypeIcon type={constants.EDITOR_TEMPLATES.RATING_1}
                                style={{
                                    cursor: 'pointer',
                                    stroke: '#aaa', strokeWidth: 1,
                                    fill: isActive ? color : '#ffffff',
                                }}

                            />
                        </div>
                    );
                })}
            </div>
        </div>);
};


export default SurveyEditorRatingPreview;
